import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import {CustomHttpResponse} from '../model/custom-http-response';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private token: string | null | undefined = null;
  private jwtHelper: JwtHelperService;
  private loggedInUsername: string | null = null;
  host = environment.apiUrl;

  constructor(private http: HttpClient, jwtHelper: JwtHelperService) {
    this.jwtHelper = jwtHelper;

  }

  public login(email: string, password: string): Observable<HttpResponse<CustomHttpResponse>> {
    const body = {email, password};

    return this.http
      .post<CustomHttpResponse>(
        `${this.host}/v1/staff/auth/login`, body, {observe: 'response'}
      );

  }

  public saveToken(token: string | null | undefined): void {
    this.token = token;
    if (typeof token === "string") {
      localStorage.setItem('token', token);
    }
  }

  public getToken(): string | null {
    return localStorage.getItem('token');
  }

  private isTokenValid(): boolean {
    if (this.token != null && this.token != '') {
      const {sub} = this.jwtHelper.decodeToken(this.token);
      if (sub != null && sub !== '' && !this.jwtHelper.isTokenExpired(this.token)) {
        this.loggedInUsername = sub;
        return true;
      }
    }
    return false;
  }

  public loadToken(): void {
    this.token = localStorage.getItem('token')
  }

  public isLogin(): boolean {
    this.loadToken();
    if (this.isTokenValid()) {
      return true;
    } else {
      this.token = null;
      localStorage.removeItem('token');
      return false;
    }
  }

  logout(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http
      .post<CustomHttpResponse>(
        `${this.host}/v1/staff/auth/logout`, '', {observe: 'response'}
      );
  }


}
